__turbopack_context__.v({
  "ModalQuickView": "RecommendedProduct-module__D2vTYq__ModalQuickView",
  "container": "RecommendedProduct-module__D2vTYq__container",
  "content": "RecommendedProduct-module__D2vTYq__content",
  "product": "RecommendedProduct-module__D2vTYq__product",
  "product-rec": "RecommendedProduct-module__D2vTYq__product-rec",
  "products": "RecommendedProduct-module__D2vTYq__products",
  "recommendedProduct": "RecommendedProduct-module__D2vTYq__recommendedProduct",
  "text": "RecommendedProduct-module__D2vTYq__text",
});
